import { PlusIcon } from '@heroicons/react/24/outline';

import { useOrganizationSettingsRetrieveQuery } from '../external/bambi-api/bambiApi';
import { Logo } from '../Logo';
import { useAppSelector } from 'src/app/store/hooks';
import { selectCurrentOrganization } from 'src/features/auth/selectors';

export function NavLogo() {
  const currentOrganization = useAppSelector(selectCurrentOrganization);
  const { data: organizationSettings } = useOrganizationSettingsRetrieveQuery(
    {},
    {
      skip: !currentOrganization?.id,
    }
  );
  return (
    // The link's content is an inline <svg> with no title plus an optional org
    // logo, so without this the home link has no accessible name at all.
    <a
      href="/"
      aria-label="Bambi home"
      className="flex flex-row items-center gap-2"
    >
      <Logo />
      {organizationSettings?.logo ? (
        <span className="flex flex-row items-center gap-1">
          <PlusIcon className="w-4" />
          <img
            src={organizationSettings.logo}
            alt="Organization Logo"
            style={{ width: 100, height: 50 }}
          />
        </span>
      ) : null}
    </a>
  );
}
